import { render } from "./Footer.vue?vue&type=template&id=532d0648&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=532d0648&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532d0648"]])

export default __exports__